<div class="filter-row">
  <div class="filter-section date-filter">
    <mat-form-field class="small-input-width">
      <input readonly="true" matInput [matDatepicker]="periodfrom" [value]="request.fromDate"
        (dateChange)="periodFromDateChange($event)" placeholder="Period from">
      <mat-datepicker-toggle matSuffix [for]="periodfrom"></mat-datepicker-toggle>
      <mat-datepicker #periodfrom></mat-datepicker>
      <mat-label>Period from</mat-label>
    </mat-form-field>

    <mat-form-field class="small-input-width">
      <input readonly="true" matInput [matDatepicker]="perioduntil" [value]="request.toDate"
        (dateChange)="periodUntilDateChange($event)" placeholder="Period until">
      <mat-datepicker-toggle matSuffix [for]="perioduntil"></mat-datepicker-toggle>
      <mat-datepicker #perioduntil></mat-datepicker>
      <mat-label>Period until</mat-label>
    </mat-form-field>
  </div>

  <div class="filter-section group-filter">
    <div style="margin-bottom:5px;"><strong>Group by</strong></div>
    <div>
      <mat-checkbox [(ngModel)]="request.groupByMonth">Month
      </mat-checkbox>
    </div>
  </div>

  <div class="filter-section buttons">
    <button class="export-button" mat-flat-button (click)="downloadExcel()">Export</button>
    <button mat-flat-button (click)="getReport()">Search</button>
  </div>
</div>